/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export const checkLogin = async (username, captcha, key) => {
  try {
    const url = generateApiUrl(["auth", "check_login"]);
    const payload = { username, captcha, key };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    return {
      state: pathOr(null, ["state"], data),
      username: pathOr(null, ["username"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const auth = async (mode, username, password, captcha, key, code) => {
  try {
    const url = generateApiUrl(["auth", "auth"]);
    const payload = {
      mode,
      username,
      password,
      captcha,
      key,
      code,
    };
    const response = await doLogin(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const twoStep = async (username, password, code) => {
  try {
    const url = generateApiUrl(["auth", "two_step"]);
    const mode = "two_step";
    const payload = {
      mode,
      username,
      password,
      code,
    };
    const response = await doLogin(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const authMobile = async (mobile, code, controlCode) => {
  try {
    const url = generateApiUrl(["auth", "auth_mobile"]);
    const payload = {
      mode: "login",
      mobile,
      two_step_code: code,
      control_code: controlCode,
    };
    const response = await doLogin(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const doLogin = async (url, params) => {
  try {
    const payload = {
      ...params,
      grant_type: "password",
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      scope: "*",
    };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    const isTwoStep = pathOr(null, ["is_two_step"], data);
    const resExpireSeconds = pathOr(300, ["expire_seconds"], data);
    const routeName = pathOr("dashboard", ["route_name"], data);
    const parvandehCount = pathOr(0, ["parvandeh_count"], data);
    const activeParvandeh = pathOr(null, ["current_parvandeh"], data);
    const mobile = pathOr(null, ["mobile"], data);
    const message = pathOr(null, ["data", "message"], response);

    /* guidance: get all enumeration when logged in */
    if (activeParvandeh) {
      localStorage.setItem("afterLoginRoute", routeName);
      localStorage.setItem("activeParvandeh", JSON.stringify(activeParvandeh));
      localStorage.setItem("parvandehCount", JSON.stringify(parvandehCount));
      await parvandehChangeRole(activeParvandeh);
      store.dispatch("getAllEnumeration");
    }

    return {
      isTwoStep,
      resExpireSeconds,
      mobile,
      routeName,
      message,
    };
  } catch (error) {
    throw error;
  }
};
export const generateOtpCodeWt = async (mode, mobile, captcha, key) => {
  try {
    const url = generateApiUrl(["auth", "generate_otp_code_wt"]);
    const payload = {
      model_request: mode,
      mobile,
      captcha,
      key,
    };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    return {
      controlCode: pathOr(null, ["control_code"], data),
      resExpireSeconds: pathOr(300, ["expire_seconds"], data),
      mobile: pathOr(null, ["mobile"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const changePassword = async (mobile, password, code, controlCode) => {
  try {
    const url = generateApiUrl(["auth", "change_password"]);
    const payload = {
      mobile,
      password,
      two_step_code: code,
      control_code: controlCode,
    };
    const response = await httpService.put(url, payload);
    return {
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
export const contactUs = async (name, family, mobile, description) => {
  try {
    const url = generateApiUrl(["auth", "contact_us"]);
    const payload = {
      name,
      family,
      mobile,
      description,
      national_code: null,
      tel: null,
      subject: null,
      company_code: process.env.VUE_APP_COMPANY_CODE || null,
    };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    return {
      id: pathOr(null, ["id"], data),
      trackingCode: pathOr(null, ["tracking_code"], data),
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
export const signOut = async () => {
  try {
    const url = generateApiUrl(["auth", "logout"]);
    const response = await httpService.post(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};

// TODO: temporary use of service parvandeh change role after auth
export const parvandehChangeRole = async (parvandeh) => {
  try {
    const url = generateApiUrl(["globalServices", "parvandeh_change_role"]);
    const parvandehCode = pathOr(null, ["code"], parvandeh);
    const payload = { code: parvandehCode };
    await httpService.put(url, payload);
  } catch (error) {
    throw error;
  }
};
